import { BrightnessVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { brightness } from '@cloudinary/url-gen/actions/adjust'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { SliderField } from './SliderField'

export const BrightnessVariant = (props: BrightnessVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={-99}
        maxValue={100}
        step={1}
        pinnedValue={0}
        initialValue={variant.qualifier ?? 80}
        label="Adjust image brightness"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.adjust(brightness(value))
          imageStore.clearVariants()
          imageStore.createVariant({
            image,
            url: variant.image.toURL(),
            action: 'brightness',
            qualifier: value,
          })
        }}
      />
    </ImageVariant>
  )
}
